import type {
  TDropdownValue,
  IDropdownSelectOption,
  ICustomInputConfig,
} from './types';

/**
 * 根据当前 value 计算按钮上展示的文案
 * 自定义且无值时用 customInput.label，否则用选项 label 或 'Auto'
 */
export const getDisplayText = (
  value: TDropdownValue,
  options: IDropdownSelectOption[],
  customInput?: ICustomInputConfig,
  formatCustomDisplay?: (value: number) => string,
): string => {
  if (value && typeof value === 'object' && (value as any).type === 'custom') {
    const v = (value as any).customValue;
    if (v === undefined || v === null || v === '') {
      return customInput?.label || 'Custom Value';
    }
    const num = Number(v);
    if (formatCustomDisplay && !isNaN(num) && isFinite(num)) {
      return formatCustomDisplay(num);
    }
    return String(v);
  }
  const match = options?.find((o) => String(o.value) === String(value));
  return (match?.label as string) || (value as any) || 'Auto';
};

/** 判断某预设选项是否为当前选中（value 为自定义时预设均未选中） */
export const isOptionSelected = (
  opt: IDropdownSelectOption,
  value: TDropdownValue
): boolean => {
  if (value && typeof value === 'object' && (value as any).type === 'custom') {
    return false;
  }
  return (
    value === null ||
    value === undefined ||
    String(opt.value) === String(value)
  );
};

/** 判断当前是否为「自定义」选中态 */
export const isCustomSelected = (value: TDropdownValue): boolean => {
  return !!(
    value &&
    typeof value === 'object' &&
    (value as any).type === 'custom'
  );
};
